<template>
  <dy-dialog v-model="visible" width="70%" title="选择房屋" confirm-title="确定" :show-confirm="multiple ? !!selectRows.length : !!selectRow"
             @onConfirm="handleSelected" append-to-body  @onClose="handleClose">
    <dy-main-container class="select-asset-dialog" hide-top-menu>
      <template #left>
        <DyOrgManagement
          ref="leftTreeRef"
          :table-list-api="api.getAssetTree"
          data-path="data"
          :width="dividerOption.leftAsideWidth"
          @onchange="handleOrgSelected"
          :table-columns="tableColumns"
        />
      </template>
      <template #right>
        <avue-crud ref="crud" :page.sync="page" :data="tableList" :table-loading="tableLoading" @on-load="getList"
                   :option="crudOption" @search-change="searchChange" @row-click="rowClick" :search.sync="searchForm"
                   @selection-change="selectionChange">
          <template slot="radio" slot-scope="{row}">
            <el-radio v-model="selectRowIndex" :label="row.$index">&nbsp;</el-radio>
          </template>
        </avue-crud>
      </template>
    </dy-main-container>
  </dy-dialog>
</template>

<script>
import {getTableOption} from '@/const/crud/baseData/houseList';
import {getBuildingInTree} from "@/api/v3/assets/assets";
import {mapGetters} from "vuex";
import {getHouseList} from '@/api/v3/assets/house'
import store from "@/store";
import DyDialog from "@/components/DYDialog/index.vue";

export default {
  name: 'DySelectHouseDialog',
  components: {DyDialog},
  data() {
    return {
      visible: false,
      assetType: 0,
      leftOrgInfo: undefined,
      selectRow: undefined,
      selectRows: [],
      selectRowIndex: undefined,
      multiple: false,
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      dividerOption: {
        leftAsideWidth: 225,
        leftAsideMinWidth: 200
      },
      searchForm: {},
      crudOption: undefined,
      tableList: undefined,
      tableLoading: false,
      tableColumns: [
        {
          label: '名称',
          prop: 'name',
          width: '70',
          mainColumn: true,
          mainColumnIcon: (row, index) => {
            return (row.type && row.type.indexOf('LC') > -1) ? 'icon-file' : 'icon-folder'
          }
        },
      ],
      api: {
        getAssetTree: () =>
          getBuildingInTree({
            organizationId: this.organizationId,
          })
      },
    }
  },
  computed: {
    project() {
      return store.getters.project
    },
    permissions() {
      return store.getters.permissions
    },
    organizationId() {
      return store.getters.organizationId
    },
  },
  methods: {
    open(params) {
      const {searchParams, resolve, cancel, multiple} = params || {}
      this.resolve = resolve
      this.cancel = cancel
      this.multiple = !!multiple
      this.selectRow = undefined
      this.selectRows = []
      this.selectRowIndex = undefined
      const crudOption = getTableOption()
      crudOption.menu = false
      crudOption.index = false
      crudOption.height = 380
      crudOption.searchMenuSpan = 18
      crudOption.selection = this.multiple
      if (!this.multiple) {
        crudOption.column.unshift({
          prop: 'radio',
          width: 60,
        })
      }
      this.crudOption = crudOption
      this.visible = true
      Object.assign(this.searchForm, searchParams)
      this.getList()
    },
    searchChange(form, done) {
      this.getList()
      done()
    },
    async getList() {
      this.tableLoading = true
      const form = {
        ...this.searchForm,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        projectCode: this.project.code,
      }
      const res = await getHouseList(form)
      this.tableList = res.data.records
      this.page.total = Number(res.data.total)
      this.tableLoading = false
    },
    handleSelected() {
      this.visible = false
      const result = this.multiple ? this.selectRows : this.selectRow
      this.$emit('confirm', result)
      this.resolve && this.resolve(result)
    },
    handleClose() {
      this.selectRow = undefined
      this.selectRows = []
      this.selectRowIndex = undefined
      this.cancel && this.cancel()
    },
    rowClick(row) {
      if (this.multiple) return
      this.selectRow = row
      this.selectRowIndex = row.$index
    },
    selectionChange(rows) {
      this.selectRows = rows || []
    },
    handleOrgSelected(org) {
      this.leftOrgInfo = org
      this.searchForm.pid = org.id
      this.getList()
    },
  }
}
</script>

<style scoped lang="scss">

.select-asset-dialog {
  height: 600px;
  overflow: hidden;
}

</style>
